module.exports = __webpack_public_path__ + "img/icon3.4453c6bf.png";